export const textValue = (value: unknown): string =>
  typeof value === "string" && value.trim() ? value : "Non renseigné"
export function dateValue(value: unknown, time = false) {
  if (typeof value !== "string" || !value) return "Non renseigné"
  const date = new Date(/^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T12:00:00` : value)
  return Number.isNaN(date.getTime())
    ? value
    : new Intl.DateTimeFormat("fr-FR", {
        dateStyle: "medium",
        ...(time ? { timeStyle: "short" as const } : {}),
      }).format(date)
}
